/**
 * Production Router Configuration
 * Only includes public-facing routes ready for launch
 * Optimized with lazy loading for better performance
 */

import React, { lazy, Suspense } from "react";
import { createBrowserRouter, Outlet } from "react-router-dom";
import AppWrapper from "../AppWrapper";
import RouteWrapper from "../Components/GlobalSearch/RouteWrapper";

// Loading component for lazy loaded routes
const RouteLoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-900 to-black">
    <div className="text-center">
      <div className="w-16 h-16 border-4 border-cyan-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
      <p className="text-cyan-400 text-lg animate-pulse">Loading realm...</p>
    </div>
  </div>
);

// Lazy load all production components
const RealmsOverview = lazy(() => import("../RiseOfRealms/RealmsOverview"));
const RiseOfRealmsSearch = lazy(() => import("../RiseOfRealms/Search/page"));
const CardDetail = lazy(() => import("../RiseOfRealms/CardDetail"));
const LandingPage = lazy(() => import("../Pages/LandingPage"));
const NotFound = lazy(() => import("../Pages/NotFound"));

// Main App Layout with nested routes
const AppLayout = () => {
  return (
    <AppWrapper>
      <Suspense fallback={<RouteLoadingFallback />}>
        <Outlet />
      </Suspense>
    </AppWrapper>
  );
};

// Production routes - only public-facing pages
const productionRoutes = [
  {
    path: "/",
    element: <RealmsOverview />, // Landing page with "Enter the Multiverse"
  },
  {
    path: "/realms",
    element: <RealmsOverview />,
  },
  {
    path: "/rise-of-realms/search",
    element: <RiseOfRealmsSearch />,
  },
  {
    path: "/cards/:id",
    element: <CardDetail />,
  },
  {
    path: "/about",
    element: <LandingPage />,
  },
  {
    path: "/rise-of-realms/realms/:realmId",
    element: <RealmsOverview />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

// Create production router with proper nesting
const routerConfig = [
  {
    element: <AppLayout />,
    children: [
      {
        element: <RouteWrapper />,
        children: productionRoutes,
      },
    ],
  },
];

export const productionRouter = createBrowserRouter(routerConfig);

// Export route stats for debugging
export const productionRouteStats = {
  total: productionRoutes.length,
};

console.log(
  "🚀 Production router initialized with",
  productionRouteStats.total,
  "public routes (lazy loaded)"
);